import { environment } from 'environments/environment';

// Fonte única da base URL: reusa o environment do Angular (trocado por ambiente no build).
export const API_BASE_URL: string = environment.urlApi;
